import type { CSSObject, SystemStyleObject } from '@chakra-ui/react'

export const usePointerFocusStyles = (customStyles: SystemStyleObject): { sx: CSSObject } => ({
  sx: {
    '[data-js-focus-visible] &:focus:not([data-focus-visible-added])': customStyles,
  },
})
